// extracted by mini-css-extract-plugin
module.exports = {"link":"styles-module--link--3xlwE","text":"styles-module--text--1KyD9","svg":"styles-module--svg--tz9WQ"};